import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  delay = 0
}: SectionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={`max-w-2xl mx-auto px-6 ${className}`} data-id="element-214">
      {children}
    </motion.div>;
}